import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const brandExpandRouter: Array<RouteRecordRaw> = [
    {
        path: '/brand-expand',
        component: Layout,
        name: '品牌拓展',
        redirect: '/brand-expand/project',
        meta: { title: '品牌拓展', icon: 'icon-brand', alwaysShow: true },
        children: [
            {
                path: 'project',
                name: '项目列表',
                component: () => import('@/views/brand-expand/Project.vue'),
                meta: { title: '项目列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'project-detail',
                name: '项目详情',
                component: () => import('@/views/brand-expand/ProjectDetail.vue'),
                meta: { title: '项目详情' }
            },
            {
                path: 'project-brand',
                name: '项目品牌',
                component: () => import('@/views/brand-expand/ProjectBrand.vue'),
                meta: { title: '项目品牌', keepAlive: true, depth: 30 }
            },
            {
                path: 'project-brand-detail',
                name: '项目品牌详情',
                component: () => import('@/views/brand-expand/ProjectBrandDetail.vue'),
                meta: { title: '项目品牌详情' }
            },
            {
                path: 'brand',
                name: '完善品牌',
                component: () => import('@/views/brand-expand/Brand.vue'),
                meta: { title: '完善品牌', badge: 'perfect' }
            },
            {
                path: 'progress-service',
                name: '商家进度（客服）',
                component: () => import('@/views/brand-expand/Progress.vue'),
                meta: { title: '商家进度（客服）', keepAlive: true, depth: 30, role: 2, badge: 'service' }
            },
            {
                path: 'progress-business',
                name: '商家进度',
                component: () => import('@/views/brand-expand/Progress.vue'),
                meta: { title: '商家进度', keepAlive: true, depth: 30, role: 1, badge: 'business' }
            },
            {
                path: 'progress-detail',
                name: '商家进度详情',
                component: () => import('@/views/brand-expand/ProgressDetail.vue'),
                meta: { title: '商家进度详情' }
            }
        ]
    }
]

export default brandExpandRouter